<template>
  <div class="flex column v2-daterange-picker">
    <div class="text-grey-8" v-if="displayLabel">期間選択</div>
    <date-range-picker
      ref="picker"
      :opens="opens"
      :dateRange="dateRange"
      v-model="dateRange"
      :ranges="false"
      :single-date-picker="true"
      :locale-data="customLocale"
    >
      <template v-slot:input="picker">
        <div class="row items-center justify-between">
          <!-- Date text -->
          <div class="text-grey-8">{{ formatDate(picker) }}</div>

          <!-- Right-aligned icons -->
          <div class="row items-center q-gutter-xs q-ml-auto">
            <q-icon
              name="close"
              class="cursor-pointer text-grey-6"
              size="sm"
              v-if="dateRange.startDate !== ''"
              @click="onClearDateRangeChange()"
            />
            <q-icon name="event" class="cursor-pointer text-grey-6" size="sm" />
          </div>
        </div>
      </template>
      <template v-slot:footer="data">
        <div class="row justify-end q-pa-sm" style="border-top: 1px solid #ddd">
          <q-btn no-caps flat class="btn-cancel q-mr-sm" @click="data.clickCancel">{{ $t('cancel') }} </q-btn>
          <q-btn no-caps class="btn-save" @click="onSelect(data)" :disable="data.in_selection">
            {{ $t('save') }}
          </q-btn>
        </div>
      </template>
    </date-range-picker>
  </div>
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component'
import { maska } from 'maska'
import AppMixin from '@/components/app/mixins/AppMixin.vue'
import BaseFormMixin from '@/components/common/mixins/BaseFormMixin.vue'
import { IDateRangePicker } from '@/utils/types'
import { Prop } from 'vue-property-decorator'
import moment from 'moment'
import { useQuasar } from 'quasar'
import DateRangePicker from 'vue3-daterange-picker'
import { localeData } from '@/utils/datetime'
@Options({
  components: { DateRangePicker },
  directives: { maska },
  emits: ['update:onChangeDateRange', 'update:modelValue'],
})
export default class DateSelectorV3 extends mixins(AppMixin, BaseFormMixin) {
  @Prop()
  modelValue!: string

  @Prop()
  disable!: boolean

  @Prop({ default: 'left' })
  opens!: string

  @Prop()
  displayLabel!: boolean

  @Prop({ default: 150 })
  inputWidth!: number

  @Prop({ default: 24 })
  iconSize!: number

  @Prop({ default: 12 })
  fontSize!: number

  @Prop()
  isClear!: boolean

  dateFormat = 'YYYY-MM-DD'
  customLocale = localeData(this.dateFormat)

  dateRange: IDateRangePicker = {
    startDate: '',
    endDate: '',
  }

  quasar = useQuasar()

  get value() {
    return this.modelValue
  }

  set value(value) {
    this.$emit('update:modelValue', value)
  }

  onClearDateRangeChange() {
    this.dateRange = {
      startDate: '',
      endDate: '',
    }
    this.value = ''
  }

  formatDate(date) {
    if (date.startDate) {
      const val = moment(date.startDate).format(this.dateFormat)
      return val
    } else {
      return this.dateFormat
    }
  }

  onSelect(data) {
    data.clickApply()
    if (this.dateRange.startDate) {
      this.value = moment(this.dateRange.startDate).format(this.dateFormat)
    } else {
      this.value = ''
    }
  }

  created() {
    // Only set if modelValue (this.value) exists
    if (this.value) {
      this.dateRange.startDate = this.value
    }
  }
}
</script>

<style scoped  lang="scss">
.v2-daterange-picker {
  justify-content: center;
  height: 40px;
  border: 1px solid #9E9E9E;
  border-radius: 4px !important;
  .vue-daterange-picker {
    text-align: center;
    min-width: 220px !important;
    width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    :deep(.reportrange-text) {
      border: none;
      border-radius: 4px;
    }
  }
}
</style>
